import Image, { StaticImageData } from "next/image";
import React from "react";
import Link from "next/link";
import BrandedActionButton, { BrandedActionButtonProps } from "./branded-action-button";
import { BodyText, HeadlineBodyText } from "./KinsaTypography";

// Content rendered in the VisitList as either the footer or in lieu of the list.
export interface KinsaListContentWidgetProps {
  image: StaticImageData | string;
  imageAlt: string;
  headline: React.ReactNode;
  body: React.ReactNode;
  actionButtonProps?: BrandedActionButtonProps;
  href?: string;
  className?: string;
}

const KinsaListContentWidget: React.FC<KinsaListContentWidgetProps> = ({
  image,
  imageAlt,
  headline,
  body,
  actionButtonProps,
  href,
  className,
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className || ""}`}
    >
      <div className="mb-6">
        <Image src={image} alt={imageAlt} width={165} height={165} />
      </div>
      <HeadlineBodyText className="text-text-300 mb-3">
        {headline}
      </HeadlineBodyText>
      <BodyText className="text-text-100 max-w-sm leading-relaxed mb-8">
        {body}
      </BodyText>
      {actionButtonProps && href ? (
        <Link href={href} target="_blank" rel="noopener noreferrer">
          <BrandedActionButton {...actionButtonProps} />
        </Link>
      ) : (
        actionButtonProps && <BrandedActionButton {...actionButtonProps} />
      )}
    </div>
  );
};

export default KinsaListContentWidget;
